import {
  HTMLReactParserOptions,
  domToReact,
  DOMNode,
} from 'html-react-parser';

export const safeHtmlListParserOptions: HTMLReactParserOptions = {
  replace: node => {
    if (node.type === 'script' || node.type === 'style') {
      return null;
    }
    if (node.type === 'tag' && node.name === 'ul') {
      return (
        <ul className="list-disc pl-5">
          {domToReact(node.children as DOMNode[])}
        </ul>
      );
    }

     if (node.type === 'tag' && node.name === 'ol') {
      return (
        <ol className="list-decimal pl-5">
          {domToReact(node.children as DOMNode[])}
        </ol>
      );
    }
    
    if (node.type === 'tag' && node.name === 'li') {
      return (
        <li className="mb-1">
          {domToReact(node.children as DOMNode[])}
        </li>
      );
    }

    return undefined;
  },
};
